import React, { createRef, useEffect } from 'react';
import { connect } from 'react-redux';
import {
    getTopTags,
    getTotalDistilledTags,
    getTaxonomy,
    getTagsLoading,
    getTotalMlTags,
    getMlTags,
} from '../selectors';
import { getUserPermissionsKeys } from '../../auth/selectors';
import { PropTypes } from 'prop-types';
import { topTagsRequested } from '../actions';
import { DROPDOWNDATA } from './constants';
import TopTagsCard from '../../../common/TopTagsCard';
import downloadAsImage from '../../../helpers/downloadAsImage';

function TopTags({
    onLoad,
    topTags,
    totalTags,
    totalMlTags,
    taxonomy,
    tagsLoading,
    mlTags,
    permissions,
}) {
    useEffect(() => {
        onLoad(DROPDOWNDATA[0].key);
    }, []);

    const ref = createRef();

    return (
        <TopTagsCard
            id={0}
            subHeading={'Discover which tags are picked up the most.'}
            taxonomy={taxonomy}
            onTaxonomySelect={onLoad}
            topTags={topTags}
            mlTags={mlTags}
            tagsLoading={tagsLoading}
            totalTags={totalTags}
            totalMlTags={totalMlTags}
            permissions={permissions}
            downloadable={true}
            ref={ref}
            onDownloadClick={(filetype) => {
                if (ref) {
                    downloadAsImage(ref.current, 'topTags', filetype);
                }
            }}
        />
    );
}

TopTags.propTypes = {
    // function to call when a new taxonomy is selected
    // or when the component is loaded
    onLoad: PropTypes.func.isRequired,
    // tags passed to the component to render
    topTags: PropTypes.arrayOf(PropTypes.object),
    // ml tags passed to the component to render
    mlTags: PropTypes.arrayOf(PropTypes.object),
    // total tags passed to the component to render
    totalTags: PropTypes.string,
    // total count of Machine generated tags
    totalMlTags: PropTypes.string,
    // taxonomy passed to dropdown to fetch tags by
    // should be of type string e.g category
    taxonomy: PropTypes.string,
    // boolean value that determines loading state of component
    tagsLoading: PropTypes.bool,
    // array of strings that contains user permissions
    permissions: PropTypes.arrayOf(PropTypes.string),
};

TopTags.defaultProps = {
    topTags: [],
    mlTags: [],
    totalTags: 0,
    totalMlTags: 0,
    taxonomy: '',
    tagsLoading: false,
    permissions: [],
};

const mapStateToProps = (state) => {
    return {
        topTags: getTopTags(state),
        mlTags: getMlTags(state),
        totalTags: getTotalDistilledTags(state),
        totalMlTags: getTotalMlTags(state),
        taxonomy: getTaxonomy(state),
        tagsLoading: getTagsLoading(state),
        permissions: getUserPermissionsKeys(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onLoad: (taxonomy) => dispatch(topTagsRequested(taxonomy)),
    };
};

const ConnectedTopTags = connect(mapStateToProps, mapDispatchToProps)(TopTags);

export default ConnectedTopTags;
